(function () {
  'use strict';
 
  function openPanel(root, trigger, panel, allowMultiple) {
    if (!allowMultiple) {
      root.querySelectorAll('.pa-trigger[aria-expanded="true"]').forEach(function (t) {
        if (t !== trigger) {
          var sib = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (sib) closePanel(t, sib);
        }
      });
    }
 
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('aria-hidden');
    panel.style.display = 'block';
    panel.style.overflow = 'hidden';
 
    var inner = panel.querySelector('.pa-panel__inner');
    var targetH = inner ? inner.scrollHeight : 0;
 
    panel.style.height = '0px';
    void panel.offsetHeight; // force reflow
    panel.style.height = targetH + 'px';
 
    panel.addEventListener('transitionend', function onOpen() {
      panel.style.height = 'auto'; // let it reflow naturally after open
      panel.removeEventListener('transitionend', onOpen);
    }, { once: true });
 
    // lazy-load media inside panel on first open
    panel.querySelectorAll('[data-src]').forEach(function (el) {
      el.src = el.dataset.src;
      el.removeAttribute('data-src');
    });
    panel.querySelectorAll('[data-srcset]').forEach(function (el) {
      el.srcset = el.dataset.srcset;
      el.removeAttribute('data-srcset');
    });
  }
 
  function closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
 
    // collapse from current height back to 0
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight; // force reflow
    panel.style.height = '0px';
 
    panel.addEventListener('transitionend', function onClose() {
      panel.style.display = 'none';
      panel.removeEventListener('transitionend', onClose);
    }, { once: true });
  }
 
  function initAccordion(root) {
    // guard against double-init
    if (root.dataset.paInit) return;
    root.dataset.paInit = '1';
 
    var allowMultiple = root.hasAttribute('data-pa-multiple');
 
    root.querySelectorAll('.pa-trigger').forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;
 
      // ensure closed state on init
      panel.style.display = 'none';
      panel.style.height = '0px';
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
 
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closePanel(trigger, panel);
        } else {
          openPanel(root, trigger, panel, allowMultiple);
        }
      });
 
      trigger.addEventListener('keydown', function (e) {
        var all = Array.from(root.querySelectorAll('.pa-trigger'));
        var idx = all.indexOf(trigger);
        if (e.key === 'ArrowDown') { e.preventDefault(); (all[idx + 1] || all[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (all[idx - 1] || all[all.length - 1]).focus(); }
        else if (e.key === 'Home') { e.preventDefault(); all[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); all[all.length - 1].focus(); }
      });
    });
  }
 
  function init() {
    document.querySelectorAll('[data-pa]').forEach(initAccordion);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  document.addEventListener('shopify:section:load', init);
}());